module.exports = __webpack_public_path__ + "img/olie.b39068b0.jpeg";